
import Vue from 'vue';
import axios, { AxiosResponse } from 'axios';
import _ from 'lodash';
import { GoodsObject } from '@/models/GoodsObject';

export default Vue.extend({
  props: {
    passedKey: { type: Number, default: -1 },
    processIndex: { type: Number, default: -1 },
    ftProcessRow: { type: Object, default: () => {}},
    rules: { type: Array, default: () => []},
    goodsFilter: { type: Object, default: () => {}},
    goodsNameField: { type: String, default: '' },
    disabled: { type: Boolean, default: () => false }
  },
  data(): {
    isLoading: boolean,
    search: string | null,
    searchResults: any[],
    searchTimerId: any
  } {
    return {
      isLoading: false,
      search: null,
      searchResults: [],
      searchTimerId: null
    }
  },
  computed: {
    items (): GoodsObject[] {
      const initialGoods = this.$store.state.goods.items;
      const searchedGoods = this.searchResults.map((good: any) => new GoodsObject(good, this.ftProcessRow));
      const mergedGoods = _.unionBy(initialGoods, searchedGoods, '_id');
      let filteredGoods: any[] = mergedGoods;
      if(this.goodsFilter) {
        const filterKeys = Object.keys(this.goodsFilter);
        filteredGoods = mergedGoods.filter((good: any) => {
          return filterKeys.reduce((accumulator, currentValue) => {
            return accumulator && this.goodsFilter[currentValue].includes(good[currentValue]);
          }, true);
        });
      }
      return filteredGoods;
    }
  },
  watch: {
    search (val) {
      if (!val) {
        return;
      }
      this.isLoading = true;
      this.fetchEntriesDebounced();
    }
  },
  methods: {
    customFilter(item: any, queryText: string) {
      return item[this.goodsNameField].toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    },
    fetchEntriesDebounced() {
      clearTimeout(this.searchTimerId)
      this.searchTimerId = setTimeout(async () => {
        await this.fetchEntries()
      }, 500) /* 500ms throttle */
    },
    async fetchEntries() {
      try {
        let filters: any = {};
        if(this.goodsFilter) {
          const filterKeys = Object.keys(this.goodsFilter);
          filterKeys.forEach((fieldName: string) => {
            filters[fieldName] = this.goodsFilter[fieldName];
          });
        }
        const response: AxiosResponse<any> = await axios.get(`/api/v2/goods/search`, { params: { q: this.search, page: 1, filters } });
        this.searchResults = _.get(response, 'data.data.docs', []);
      }
      catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
      finally {
        this.isLoading = false;
      }
    },
    onChange() {
      const goodsObject = this.items.find(item => item._id == this.ftProcessRow._id);
      this.$store.commit('updateSingleGood', goodsObject);
      this.$emit('change');
    }
  }
})
